import { render, staticRenderFns } from "./start-school.vue?vue&type=template&id=c453b0b8"
import script from "./start-school.vue?vue&type=script&lang=ts"
export * from "./start-school.vue?vue&type=script&lang=ts"
import style0 from "./start-school.vue?vue&type=style&index=0&id=c453b0b8&prod&module=true&lang=stylus"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports